import dayjs from "dayjs";
import { store } from "../store";

const getDisplayTZ = () => store.getState().settings?.displayTimezone || "America/Caracas";

export const fmtDt = (d) => (d ? dayjs(d).tz(getDisplayTZ()).format("DD/MM/YYYY HH:mm") : "—");
